export const activityConstants = {
  CREATE_ACTIVITY: "CREATE_ACTIVITY",
  UPDATE_ACTIVITY: "UPDATE_ACTIVITY",
  GET_ACTIVITY: "GET_ACTIVITY",
  GET_ACTIVITY_BY_ID: "GET_ACTIVITY_BY_ID",
  DELETE_ACTIVITY: "DELETE_ACTIVITY",
  GET_ACTIVITY_LIST: "GET_ACTIVITY_LIST",
  GET_INVOICE_BY_ACTIVITY_ID: "GET_INVOICE_BY_ACTIVITY_ID",
  GENERATE_INVOICE_BY_ACTIVITY_ID: "GENERATE_INVOICE_BY_ACTIVITY_ID",
  GET_ALL_INVOICES: "GET_ALL_INVOICES",
  GET_ACCEPTED_ACTIVITIES: "GET_ACCEPTED_ACTIVITIES"
};
